import { ADMINS_TABLE } from './table';
import { ADMINS_PAGE } from './page';
import { ADMINS_FORM } from './form';
export const ADMINS_TRANSLATION = {
    ...ADMINS_TABLE,
    ...ADMINS_PAGE,
    ...ADMINS_FORM
};
